import React from 'react'
import { Button, Container } from 'react-bootstrap';
import styles from './home.module.scss';

const HomeNewsletter = () => {
    return (<>
        <div className={styles.light}>
            <Container className={styles.mainContainer + ' ' + 'centerText'}>
                <h3>Stay Up To Date</h3>
                <p class="lead">Sign up to receive announcements and updates on the newest quality indicators and AHRQ software.</p>
                <Button href="https://subscriptions.ahrq.gov/accounts/USAHRQ/subscriber/new?topic_id=USAHRQ_39" variant="primary">Sign up for the newsletter</Button>
            </Container>
        </div>
    </>)
}

export default HomeNewsletter;